import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './lib/datepicker.css';
import * as serviceWorker from './serviceWorker';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
  } from "react-router-dom";

import UserEditInternal from './containers/users/edit.internal';
import UserEditExternal from './containers/users/edit.external';
import Users from './containers/users'

import { Provider } from "react-redux";
import configureStore from "./store";
import { AppManager, userSession$ } from 'top-app-manager';
import 'top-app-manager/dist/index.css';
import * as appConfig from './config/app-config.json';

export const authConfig = {
    "region": appConfig.region,
    "userPool": appConfig.userPool,
    "userPoolBaseUri": appConfig.userPoolBaseUri,
    "clientId": appConfig.clientId,
    "callbackUri": appConfig.callbackUri,
    "signoutUri": appConfig.signoutUri,
    "tokenScopes": [
        "openid",
        "email"
    ],
  
    appsConfigUrl: 'https://central.smartbrandscompany.com/assets/apps.json'
  };

const renderApp = session => {
    ReactDOM.render(
        <Provider store={store}>
            <AppManager config={authConfig} />
            
            {session ?
            <Router>
                <Switch>
                    <Route path="/user/create">
                        <UserEditInternal />
                    </Route>
                    
                    <Route path="/user/:id">
                        <UserEditInternal />
                    </Route>

                    <Route path="/external/create">
                        <UserEditExternal />
                    </Route>
                    
                    <Route path="/external/:id">
                        <UserEditExternal />
                    </Route>
    
                    <Route path="/">
                        <Users />
                    </Route>
                    
                    {/* <Route exact path="/" component={() => <Redirect to='/users' />} /> */}
                </Switch>
            </Router>
            : null}
        </Provider>,
        document.getElementById('root')
    );
}
  

const store = configureStore();
userSession$.subscribe(session => {
    renderApp(session)
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
